export default {"src":"/_next/static/media/minus.1eed024b.svg","height":4,"width":30};